import React from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import { FilledButton } from "@jsluna/button";

import { resendVerifyTokenAction } from "actions/resendVerifyToken.action";
import { validateEmail } from "utils/validation";
import {
  FAILURE_MESSAGE,
  TRY_AGAIN,
  INVALID_EMAIL_MESSAGE,
} from "constants/messages";

import EmailInput from "../../EmailInput";
import PageFormat from "../../PageFormat";

class AccountVerificationError extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      success: false,
      error: false,
      sending: false,
      username: "",
      usernameValid: false,
      formValid: false,
      formErrors: { username: "" },
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (this.state.formErrors[name] !== "" || this.state[name + "Valid"]) {
        value !== ""
          ? this.validateField(value)
          : this.setState({
              usernameValid: false,
              formErrors: { username: "" },
            });
      } else {
        this.setState({
          usernameValid: false,
          formValid: validateEmail(value),
        });
      }
    });
  };

  handleBlur = (event) => {
    const { value } = event.target;
    this.validateField(value);
  };

  handleClick = (event) => {
    this.setState({
      success: false,
      error: false,
      sending: true,
    });
    event.preventDefault();
    const { dispatch } = this.props;
    dispatch(
      resendVerifyTokenAction.resendFromExpiredToken(this.state.username)
    );
  };

  validateField(value) {
    let fieldValidationErrors = this.state.formErrors;
    let usernameValid = this.state.usernameValid;

    usernameValid = validateEmail(value);
    fieldValidationErrors.username = usernameValid ? "" : INVALID_EMAIL_MESSAGE;

    this.setState({
      formErrors: fieldValidationErrors,
      usernameValid: usernameValid,
      formValid: usernameValid,
    });
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.error) {
      state.sending = false;
      state.error = nextProps.error;
      state.buttonDisabled = false;
    } else if (nextProps.success) {
      state.sending = false;
      state.success = nextProps.success;
    }
    return state;
  }

  render() {
    return (
      <PageFormat>
        <div className="c-hero c-hero--center">
          <h1>Email verification failed</h1>
        </div>
        <div className="ln-u-soft">
          <Notification type={NotificationStatuses.ERROR_TYPE}>
            The verification link is either invalid or has expired.
            <br />
            Please request a new one.
          </Notification>
          <br />
          <section className="ln-o-section">
            <div className="ln-c-card ln-c-card--soft">
              {this.state.error && (
                <div className="ln-u-margin-bottom*2">
                  <Notification type={NotificationStatuses.ERROR_TYPE}>
                    {FAILURE_MESSAGE} {TRY_AGAIN}
                  </Notification>
                </div>
              )}

              {this.state.success && (
                <div className="ln-u-margin-bottom*2">
                  <Notification type={NotificationStatuses.SUCCESS_TYPE}>
                    Email has been resent.
                  </Notification>
                </div>
              )}

              {!this.state.emailSent && (
                <div>
                  <EmailInput
                    label="For security please enter your email address"
                    info=""
                    handleChange={this.handleChange}
                    handleBlur={this.handleBlur}
                    {...this.state}
                  />
                  <FilledButton
                    className="ln-u-margin-bottom*2"
                    disabled={!this.state.formValid || this.state.sending}
                    onClick={this.handleClick}
                    id="submit"
                    type="submit"
                    fullWidth
                  >
                    Resend verification link
                  </FilledButton>
                </div>
              )}
            </div>
          </section>
        </div>
      </PageFormat>
    );
  }
}

AccountVerificationError.propTypes = {
  resendToken: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { sending, error, success } = state.resendTokenFromExpiredToken;
  return {
    sending,
    error,
    success,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resendToken: (email) =>
      dispatch(resendVerifyTokenAction.resendFromToken(email)),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountVerificationError);
